import { render, staticRenderFns } from "./EmentaCursoApp.vue?vue&type=template&id=13084588&"
import script from "./EmentaCursoApp.vue?vue&type=script&lang=js&"
export * from "./EmentaCursoApp.vue?vue&type=script&lang=js&"
import style0 from "./EmentaCursoApp.vue?vue&type=style&index=0&id=13084588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports